import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration } from 'actions/Site'
import { fetchDetailpakdeBenefits, createPakdeBenefits, updatePakdeBenefits } from 'actions/PakdeBenefits'
import { message } from 'antd'
import FormPakdeBenefitView from 'components/pages/webManagement/pakdeBenefits/Form'
import Helper from 'utils/Helper'
import { pickBy, identity } from 'lodash'
import history from 'utils/history'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  fetchDetailpakdeBenefits: bindActionCreators(fetchDetailpakdeBenefits, dispatch),
  createPakdeBenefits: bindActionCreators(createPakdeBenefits, dispatch),
  updatePakdeBenefits: bindActionCreators(updatePakdeBenefits, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isEdit', 'setIsEdit', false),
  withState('loadStatus', 'setLoadStatus', false),
  withState('stateFile', 'setStateFile', ''),
  withState('detailBenefits', 'setDetaildetailBenefits', {}),
  withState('isSubmit', 'setIsSubmit', false),
  withState('status', 'setStatus', false),
  withHandlers({
    handleRadio: props => () => {
      props.setStatus(!props.status)
    },
    handleUpload: props => (info) => {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (fileList.length > 0) {
        return Helper.getBase64(info.file, file => props.setStateFile(file))
      }
      return false
    },
    handleSubmit: props => (values) => {
      props.setIsSubmit(true)
      const payload = {
        ...values,
      }
      const formData = new FormData()
      Object.keys(pickBy(payload, identity)).map((item) => {
        if (item === 'icon' && payload[item]) {
          return formData.append(item, payload[item].file)
        }
        return formData.append(item, payload[item])
      })
      formData.append('active', values.active)
      if (props.match.params.id) {
        props.updatePakdeBenefits(formData, props.match.params.id)
          .then(() => {
            message.success('Pakde Benefit berhasil di update')
            props.setIsSubmit(false)
            history.push('/web-management/pak-d-benefits')
          })
          .catch((err) => {
            message.error(err)
            props.setIsSubmit(false)
          })
      } else {
        props.createPakdeBenefits(formData)
          .then(() => {
            message.success('Pakde Benefit berhasil di tambahkan')
            props.setIsSubmit(false)
            history.push('/web-management/pak-d-benefits')
          })
          .catch((err) => {
            message.error(err)
            props.setIsSubmit(false)
          })
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        match, setIsEdit, setDetaildetailBenefits, setStateFile, setStatus,
      } = this.props
      this.props.updateSiteConfiguration('breadList', ['Home', 'Web Management', 'Pak-D Benefit', 'Form'])
      this.props.updateSiteConfiguration('titlePage', 'Pak-D Benefit Form')
      if (match.params.id) {
        this.props.fetchDetailpakdeBenefits(match.params.id)
          .then((res) => {
            setDetaildetailBenefits(res.data)
            setStateFile(res.data.icon)
            setStatus(res.data.active)
          })
          .catch((err) => {
            message.error(err)
          })
        setIsEdit(true)
      }
    },
  }),
)(FormPakdeBenefitView)
